import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TuiInputModule, TuiInputPasswordModule } from '@taiga-ui/kit';
import {
  TuiButtonModule,
  TuiHintModule,
  TuiTextfieldControllerModule,
} from '@taiga-ui/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { UserLoginFormComponent } from '../../components/user-login-form/user-login-form.component';
import { RouteNames } from '../../../../route-names';
import { SignInWithGoogleComponent } from '../../components/sign-in-with-google/sign-in-with-google.component';

@Component({
  selector: 'app-user-login',
  standalone: true,
  templateUrl: './user-login.component.html',
  styleUrl: './user-login.component.scss',
  imports: [
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiInputPasswordModule,
    TuiButtonModule,
    TuiHintModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    UserLoginFormComponent,
    SignInWithGoogleComponent,
    TranslocoPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserLoginComponent {
  protected readonly RouteNames = RouteNames;
}
